import * as React from 'react';
import { ChevronRightIcon } from '@mentimeter/ragnar-visuals';
import { Button } from '@mentimeter/ragnar-ui/button';
import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { useTranslate } from '../../features/localization/translate';

export interface NavigationButtonProps extends ButtonT {
  onClick: React.MouseEventHandler<Element>;
  isLastSlide?: boolean;
}

export const NavigationButtonExperiment = ({
  onClick,
  isLastSlide = true,
}: NavigationButtonProps) => {
  // TODO: Split Migration
  const onClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick(e);
  };

  return (
    <NavigationButton onClick={onClickHandler} isLastSlide={isLastSlide} />
  );
};

export const NavigationButton = ({
  onClick,
  isLastSlide = true,
}: NavigationButtonProps) => {
  const translate = useTranslate();

  return (
    <Button
      size="large"
      iconTrailing={ChevronRightIcon}
      variant="subtle"
      mt="space4"
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {isLastSlide ? translate('buttons.finish') : translate('buttons.next')}
    </Button>
  );
};
